import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Grid,
  Typography,
  Button,
  CircularProgress,
  Alert,
  Paper,
  styled,
  useTheme,
} from "@mui/material";
import { useAuth } from "../context/AuthProvider";
import logo from "../img/athrv-cloud-logo-1.png";
import logo1 from "../img/Athrv-white.png";
import CheckIcon from "@mui/icons-material/Check";
import comingSoonImage from "../img/coming-soon.jpg";
const CustomCard = styled(Box)(({ theme }) => ({
  background: theme.palette.mode === "dark" ? "#2c2c2c" : "#F5F5F5",
  borderRadius: "0px 40px 0px 40px",
  padding: "24px",
  minHeight: "100%",
  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  "&:hover": {
    boxShadow: "0 15px 40px rgba(0,0,0,0.1)",
  },
}));

const PlansSection = () => {
  const [plans, setPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(true);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("access_token");
  const { setPlanId } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_NEW_HOST_URL}/athrv/api/v1/plan/all`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch plans");
        return res.json();
      })
      .then((data) => setPlans(data))
      .catch((err) => setError(err.message))
      .finally(() => setLoadingPlans(false));
  }, [token]);

  const handlePlanSelect = (plan) => {
    if (plan.is_published) {
      setPlanId(plan.plan_id);
      localStorage.setItem("plan_id", plan.plan_id);
      navigate(`/checkout/${plan.plan_id}`);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 4, height: "100vh" }}>
      <Box sx={{ px: 2, py: 6 }}>
        <Box sx={{ textAlign: "center", mb: 5 }}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <img
              src={theme.palette.mode === "dark" ? logo1 : logo}
              alt="Company Logo"
              style={{ height: 60 }}
            />
          </Box>

          <Typography variant="h4" fontWeight="bold" mt={2}>
            Pricing plans for everyone
          </Typography>
          <Typography variant="body1" color="textSecondary">
            No surprise fees. Cancel anytime.
          </Typography>
        </Box>

        {loadingPlans ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
            <CircularProgress size={50} />
          </Box>
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : plans.length === 0 ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
            <img
              src={comingSoonImage}
              alt="Coming Soon"
              style={{ maxWidth: "400px", width: "100%" }}
            />
          </Box>
        ) : (
          <Grid container spacing={4} justifyContent="center">
            {plans
              .filter((plan) => plan.is_published)
              .sort((a, b) => a.value - b.value)
              .map((plan) => (
                <Grid item xs={12} sm={6} md={4} key={plan.plan_id}>
                  <CustomCard
                    sx={{
                      borderTop: `6px solid ${
                        plan.is_published ? "#4F46E5" : "#ccc"
                      }`,
                    }}
                  >
                    <Typography
                      variant="h5"
                      fontWeight="bold"
                      gutterBottom
                      textAlign="left"
                    >
                      {plan.plan_name}
                    </Typography>
                    <Typography
                      variant="h4"
                      fontWeight="bold"
                      color="primary"
                      sx={{ mb: 1 }}
                    >
                      ${plan.price_per_seat}
                      <Typography
                        component="span"
                        variant="body1"
                        color="textSecondary"
                      >
                        /month
                      </Typography>
                    </Typography>

                    <Box
                      sx={{
                        mt: 2,
                        backgroundColor:
                          theme.palette.mode === "dark"
                            ? "#2c2c2c"
                            : "transparent",
                      }}
                    >
                      {Object.entries(plan.features).map(
                        ([key, val]) =>
                          val && (
                            <Box
                              key={key}
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                color: "text.secondary",
                                fontSize: "16px",
                                mb: 1,
                              }}
                            >
                              <CheckIcon
                                sx={{ color: "#4F46E5", fontSize: 20, mr: 1 }}
                              />
                              {key.replace(/_/g, " ")}
                            </Box>
                          )
                      )}
                    </Box>

                    <Button
                      fullWidth
                      variant="contained"
                      onClick={() => handlePlanSelect(plan)}
                      disabled={plan.status !== "active"}
                      sx={{
                        mt: 3,
                        textTransform: "none",
                        borderRadius: "12px",
                        backgroundColor: plan.is_published ? "#4F46E5" : "#ccc",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "18px",
                      }}
                    >
                      {plan.status === "active" ? "Choose Plan" : "Coming Soon"}
                    </Button>
                  </CustomCard>
                </Grid>
              ))}
          </Grid>
        )}
      </Box>
    </Paper>
  );
};

export default PlansSection;
